import Helpers from "../base/Helpers";

const selectors = {
  discountContainer: '#discountContainer',
  cartContainer: '.cart-wrapper__inner-inner .container',
  discountInput: '#discountInput',
  discountSubmit: '#discountSubmit',
  discountRemove: '#discountRemove',
  discountError: '#discountError',
  discountForm: '.cart-recap'
}
//if enter is pressed dont redirect to checkout
function preventSubmit() {
  $(document).on('keyup keypress', $(selectors.discountForm), function(e) { 
    if(e.keyCode == 13) {
      e.preventDefault();
      return false;
    }
  });
}

function unregisterDiscount() {
  $(selectors.discountSubmit).off('click');
  $(selectors.discountRemove).off('click');
}

function registerDiscount() {
    $(selectors.discountSubmit).on('click', e => {
      $(selectors.discountError).hide()
      const discount_code = $(selectors.discountInput).val()
      handleDiscountSubmit(discount_code);
    })
    $(selectors.discountInput).on('keyup', function (e) {
      const discount_code = $(selectors.discountInput).val()
      if (e.keyCode === 13) {
        handleDiscountSubmit(discount_code);
      }
    })
    $(selectors.discountRemove).on('click', e => {
      $(selectors.discountContainer).addClass('is-loading');
      Helpers.setCookie("discount_code", "", 365);
      Helpers.updateCartAttributes("", "", "", true)
    });
}

function showErrorMsg(data) {
  var discount_translations = ''
  if(window.__discountzMetafields){
    //in order we have multilingual shops the object needs to be checked with regex: translations_de, translations_nl
    var translation_key = Object.keys(window.__discountzMetafields).find(key => key.match(/translations_/));
    discount_translations = window.__discountzMetafields[translation_key]
  }

  if (discount_translations) { 
    if (data.code == "INVALID_TYPE" ) {
      $(selectors.discountError).html(discount_translations['VALIDATION_INVALID_TYPE']);
    } else if(data.code == "NOT_ACTIVE"){ 
      if (!!discount_translations['VALIDATION_NOT_ACTIVE']) {
        $(selectors.discountError).html(discount_translations['VALIDATION_NOT_ACTIVE']);
      }else {
        $(selectors.discountError).html(discount_translations['VALIDATION_INVALID_TYPE']);
      }
    } else if(data.code == "MIN_QUANTITY" ){
      $(selectors.discountError).html(discount_translations['VALIDATION_'+ data.code].replace("{missingQuantity}", data.data.missingQuantity))  
    } else if(data.code == "MIN_SUBTOTAL" ){ 
     // console.log("MIN_SUBTOTAL test");
      var amount = data.data.missingSubtotal 
      var countryCode=location.host.replace(/^.*\./,""); // get country code from url 
      var currency=""
      if (countryCode == 'ch') { currency=" CHF"} else {currency=" €"};  // changing currency depends on the country 
      var missingAmount =  ( amount / 100).toFixed(2).replace(/\./, ',') + currency
      $(selectors.discountError).html(discount_translations['VALIDATION_'+ data.code].replace("{missingSubtotal}", missingAmount))
    } else {
      $(selectors.discountError).html(discount_translations['VALIDATION_'+ data.code]);
    }
  }else {
    $(selectors.discountError).html('Der Gutscheincode ist nicht gültig.');
  }


  $(selectors.discountError).addClass("alert alert--error")
  $(selectors.discountError).show()
}

function handleDiscountSubmit(discount_code) {
  const url = '/apps/discountz-api'
  if (!!discount_code) {
    $(selectors.discountContainer).addClass('is-loading');
    $(selectors.cartContainer).addClass('is-loading--skeleton');
    $.getJSON('/cart.js', function(cart) {
      $.ajax({
          url: url,
          method: 'POST',
          crossDomain: true,
          dataType: "json",
          contentType: "application/json",
          data: JSON.stringify({
            locale: 'de',
            cart: cart,
            code: discount_code
          }),
          success: function (response) {
            Helpers.setCookie("discount_response", response.valid, 365);
            if (response.valid == true) {
              Helpers.setCookie("discount_code", discount_code, 365);
              $.ajax({
                url: "/discount/" + encodeURIComponent(discount_code),
                cache: false
              }).then(function(){
                let totalLineCartDiscount = response.subtotal 
                let totalLineLevelDiscount = cart.original_total_price - response.discount 
                if (response.subtotal !== totalLineLevelDiscount ) {
                  totalLineCartDiscount = totalLineLevelDiscount
                } 
             
                if(cart.attributes){
                  if(cart.attributes.discount_code == undefined || cart.attributes.discount_code != discount_code ){
                    Helpers.updateCartAttributes(discount_code, response.discount, totalLineCartDiscount, true).then(function(){
                      $(selectors.cartContainer).removeClass('is-loading--skeleton');
                    })
                  } else {
                    $(selectors.discountContainer).removeClass('is-loading');
                    $(selectors.cartContainer).removeClass('is-loading--skeleton');
                  }
                }
              })
            } else {
              if (response.code == "MIN_SUBTOTAL" ) {
                Helpers.setCookie("discount_code", discount_code, 365);  // to add discount_code in cookes if the minumim SUBTOTAL not reached too 
              }
         
              showErrorMsg(response)
              $(selectors.discountContainer).removeClass('is-loading');
              $(selectors.cartContainer).removeClass('is-loading--skeleton');
            } 
            document.dispatchEvent(new CustomEvent('discount:changed'));
          },
          error: function (xhr, status) {
            console.log("error", status);
          }
      });
    });
  }
}




export function handleDiscountSubmitForChangeQuantity(discount_code) {
  
  const url = '/apps/discountz-api'
  if (!!discount_code) {
    $(selectors.discountContainer).addClass('is-loading');
    $(selectors.cartContainer).addClass('is-loading--skeleton');
 
    $.getJSON('/cart.js', function(cart) {
      $.ajax({
          url: url,
          method: 'POST',
          crossDomain: true,
          dataType: "json",
          contentType: "application/json",
          data: JSON.stringify({
            locale: 'de',
            cart: cart,
            code: discount_code
          }),
          success: function (response) {
            if (response.valid == true) {
              Helpers.setCookie("discount_code", discount_code, 365);
              $.ajax({
                url: "/discount/" + encodeURIComponent(discount_code),
                cache: false
              }).then(function(){
                let totalLineCartDiscount = response.subtotal 
                let totalLineLevelDiscount = cart.original_total_price - response.discount
                if (response.subtotal !== totalLineLevelDiscount) {
                  totalLineCartDiscount = totalLineLevelDiscount
                } 
                if(cart.attributes){
                  if(cart.attributes.discount_code == undefined || cart.attributes.discount_code != discount_code ){
                    Helpers.updateCartAttributes(discount_code, response.discount, totalLineCartDiscount, true).then(function(){
                      $(selectors.cartContainer).removeClass('is-loading--skeleton');
                    })
                  } else {
                    $(selectors.discountContainer).removeClass('is-loading');
                    $(selectors.cartContainer).removeClass('is-loading--skeleton');
                  }
                } 
              })
            } else {
              discountInput.value = discount_code;
              showErrorMsg(response)
              $(selectors.discountContainer).removeClass('is-loading');
              $(selectors.cartContainer).removeClass('is-loading--skeleton');
            }
          },
          error: function (xhr, status) {
            console.log("error", status);
          }
      });
    });
  }
}

function checkDiscount(discount_code, cart) {
  if (!!discount_code) {
    $.ajax({
        url: '/apps/discountz-api',
        method: 'POST',
        crossDomain: true,
        dataType: "json",
        contentType: "application/json",
        data: JSON.stringify({
          locale: 'de',
          cart: cart,
          code: discount_code
        }),
        success: function (response) {
          Helpers.setCookie("discount_response", response.valid, 365);
          if (response.valid == false) {
            //console.log("response.code",response.code);  // this condation to check if the discount_code is valid but not have the requaierd 
            if (response.code == "MIN_SUBTOTAL" || response.code == "MIN_QUANTITY" ){
              var discountCodeCookie = Helpers.getCookie("discount_code")
              handleDiscountSubmitForChangeQuantity(discountCodeCookie)
             
            }else{
              Helpers.setCookie("discount_code", "", 365);
           
            }
            Helpers.updateCartAttributes("", "", "", true)
          } else {
            let totalLineCartDiscount = response.subtotal 
            let totalLineLevelDiscount = cart.original_total_price - response.discount
            if (response.subtotal !== totalLineLevelDiscount) {
              totalLineCartDiscount = totalLineLevelDiscount
            } 
            Helpers.updateCartAttributes(discount_code, response.discount, totalLineCartDiscount, true)
          }
        },
        error: function (xhr, status) {
          console.log("error", status);
        }
    });
  }
}

// document.addEventListener("DOMContentLoaded", function () {
//   registerDiscount();
  
// });




if(window.theme.pageType == 'cart'){
  document.addEventListener("DOMContentLoaded", function () {
    preventSubmit()
    registerDiscount();
    var discountCookie = Helpers.getCookie("discount_code")
    if(!!discountCookie){
      handleDiscountSubmit(discountCookie);
    }
  });

  document.addEventListener('discount:changed', function(){
    var discountCookie = Helpers.getCookie("discount_code")
    if(!!discountCookie){
      $.getJSON('/cart.js', function(cart) {
        checkDiscount(discountCookie, cart)
      })
    }
  })

  document.addEventListener('cart:rerendered', function(event){
    var discountCookie = Helpers.getCookie("discount_code")
    if(!!discountCookie && !event.detail){
      $.getJSON('/cart.js', function(cart) {
        checkDiscount(discountCookie, cart)
      })
    }
    unregisterDiscount();
    registerDiscount()
  });
}